import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/";
import BButton from "@/components/BButton";
import "./styles/vendor/tailwind/index.css";
import "./styles/index.scss";
import "./plugins";

Vue.config.productionTip = false;

Vue.component("b-button", BButton);

store.dispatch("setConfig");

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
